module.exports = __webpack_public_path__ + "img/servOrder.bd74f9e3.svg";